export const PRODUCTS_IDS = {
  healthBasic: "health_basic",
  healthUnlimited: "health_unlimited",
  glExtended: "gl_extended",
  prevention: "prevention",
};
